/* eslint-disable extra-rules/no-commented-out-code */
import useInjectReducerAndSaga from '@tcp/core/src/utils/useInjectReducerAndSaga';

export default async () => {
  const [EddReducer, EddSaga] = await Promise.all([
    import(/* webpackChunkName: "Edd" */ './EddComponent.reducer'),
    import(/* webpackChunkName: "Edd" */ './EddComponent.saga'),
  ]);
  useInjectReducerAndSaga(
    { key: 'Edd', reducer: EddReducer.default },
    { key: 'EddSaga', saga: EddSaga.default }
  );
  return null;
};
